module.exports = __webpack_public_path__ + "static/media/hint_correct.96e88f93.png";